<template>
  <v-card
    v-if="showDemoMode || !isMarkets"
    class="mt-4 d-flex"
    style="width: 100%; background-color: #121212"
  >
    <!--direct link-->
    <div
      class="d-flex"
      style="background-color: #121212; height: 40px; font-size: 0.875rem"
    >
      <template v-for="(menus, index) in menuListWithFlags">
        <router-link
          v-if="!menus.isDropDown && !menus.isDisabled"
          :key="'direct-' + index"
          :to="currentDisabled(menus).to"
          class="d-flex align-center px-4 text-decoration-none hoverable-menu"
          :class="currentDisabled(menus).class"
          style="background-color: #151515; width: 120px"
          :style="isActiveMenu(menus.menus)"
          @click.native="closeAllGroups(menus, index)"
        >
          <span>{{ menus.title }}</span>

          <span
            v-if="menus.hasBeta"
            class="ml-2 px-2 py-1 rounded-pill"
            style="
              background-color: #0073ff;
              color: #ffffff;
              font-size: 10px;
              line-height: 1;
              position: relative;
              top: -4px;
            "
          >
            {{ $t("extras.beta") }}
          </span>
        </router-link>

        <div class="d-flex align-center px-4" v-if="menus.isDisabled">
          <span style="color: #828282">{{ menus.title }}</span>
          <span
            v-if="menus.hasBeta"
            class="ml-2 px-2 py-1 rounded-pill"
            style="
              background-color: #0073ff;
              color: #ffffff;
              font-size: 10px;
              line-height: 1;
              position: relative;
              top: -4px;
            "
          >
            {{ $t("extras.beta") }}
          </span>
        </div>

        <v-menu
          v-else
          v-model="menuStates[index]"
          :key="'menu-' + index"
          offset-y
          transition="scale-transition"
          bottom
        >
          <!-- risk and execution-->
          <template v-slot:activator="{ on, attrs }">
            <div
              v-if="menus.isDropDown"
              v-bind="attrs"
              v-on="on"
              class="d-flex justify-space-between align-center px-4 hoverable-menu"
              style="background-color: #151515; cursor: pointer; width: 120px"
              :style="isActiveMenu(menus.menus)"
            >
              <span class="d-flex align-center">
                <span>{{ menus.title }}</span>
                <span
                  v-if="menus.title === $t('menus.risk')"
                  class="ml-2 px-2 py-1 rounded-pill"
                  style="
                    background-color: #0073ff;
                    color: #ffffff;
                    font-size: 10px;
                    line-height: 1;
                    position: relative;
                    top: -4px;
                  "
                >
                  {{ $t("extras.beta") }}
                </span>
              </span>
              <v-icon
                medium
                class="ml-2"
                :style="{ color: menuStates[index] ? '#0073ff' : '#ffffff' }"
              >
                {{ menuStates[index] ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </div>
          </template>
          <!--  v-if="menus.title !== $t('menus.market')" -->
          <v-list dense style="background-color: #151515">
            <v-list-item
              v-for="(menu, idx) in menus.menus"
              :key="idx"
              :disabled="menu.disabled"
              @click="handleMenuClick(menu, index)"
              :class="{
                'active-submenu': $route.path === menu.to && !menu.disabled,
                'default-disabled': menu.disabled,
              }"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <span>{{ menu.label }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </div>

    <v-spacer></v-spacer>

    <!-- DEMO MODE SWITCH 
        <v-chip v-if="showDemoMode" color="#212121" class="mr-2 mt-1">
          <v-switch
            v-model="isMockDataOn"
            color="primary"
            @change="onSwitchChange()"
            hide-details
          ></v-switch>
          <span 
            class="white--text text-capitalize"
            style="font-weight: 400;"
            :style="{ fontWeight: isMockDataOn ? 'bold' : 'normal' }"
          >
            {{ $t('toolbar.demoMode') }}
          </span>
        </v-chip> -->
  </v-card>
</template>
<script>
export default {
  emits: ["close-all-groups"],
  props: {
    menuListWithFlags: {
      type: Array,
    },
    isMarkets: {
      type: Boolean,
      default: false,
    },
    showDemoMode: {
      type: Boolean,
    },
    menuStates: {
      type: Object,
    },
  },
  methods: {
    isActiveMenu(menuList) {
      const current = this.$route.path;
      const isExact = menuList.some((m) => m.to === current);
      const isUnderGroup = menuList.some((m) => current.startsWith(m.to));
      return isExact || isUnderGroup ? "border-bottom: 5px solid #0073ff;" : "";
    },
    handleMenuClick(menu, idx) {
      if (this.$route.path === menu.to) return;
      this.closeAllGroups(idx);
      this.$router.push({ path: menu.to });
    },
    closeAllGroups(menus, index) {
      this.$emit("close-all-groups", menus, index);
    },
    currentDisabled(menus){
      //!menus.title.includes($t('menus.trading')) ? menus.menus[0].to : undefined
      const disabled =  menus.title.includes(this.$t('menus.trading')) 
      return {
        to: disabled ? '' : menus.menus[0].to,
        class: disabled ? 'disabled-class' : ''
      }
    }
  },
};
</script>
<style scoped>
.disabled-class{
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>